// Intentionally not prioritizing mp4, broken in magical ways on *some* devices
export const MEDIA_RECORDER_CODECS = [
  'video/webm; codecs=avc1', // <== mp4, inside webm, because Chrome!
  'video/webm; codecs=vp9',
  'video/webm; codecs=vp8',
  'video/webm',
  'video/mp4', // <== macOS Safari / iOS Safari
]
